module.exports = __webpack_public_path__ + "static/one-user-avatar-icon-30984f307e5a3d2b02b3a3c8c675f780.svg";